import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import MainLayout from '../layouts/MainLayout.vue'
import AdRevenueQuery from '../components/AdRevenueQuery.vue'
import SystemConfigManagement from '../components/SystemConfigManagement.vue'
import AppInfoManagement from '../components/AppInfoManagement.vue'
import UserManagement from '../components/UserManagement.vue'
import UserWithdrawalManagement from '../components/UserWithdrawalManagement.vue'
import AdminManagement from '../components/AdminManagement.vue'
import RiskManagement from '../components/RiskManagement.vue'
import CoinFlowManagement from '../components/CoinFlowManagement.vue'
import NotificationManagement from '../components/NotificationManagement.vue'
import GameManagement from '../components/GameManagement.vue'
import WebGameManagement from '../components/WebGameManagement.vue'
import LeaderGameAssign from '../components/LeaderGameAssign.vue'
import DeviceInfoManagement from '../components/DeviceInfoManagement.vue'
import DeductRecordManagement from '../components/DeductRecordManagement.vue'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/main',
      component: MainLayout,
      children: [
        {
          path: '',
          redirect: '/ad-revenue'
        },
        {
          path: '/ad-revenue',
          name: 'AdRevenueQuery',
          component: AdRevenueQuery
        },
        {
          path: '/system/config',
          name: 'SystemConfigManagement',
          component: SystemConfigManagement
        },
        {
          path: '/system/app',
          name: 'AppInfoManagement',
          component: AppInfoManagement
        },
        {
          path: '/user-management',
          name: 'UserManagement',
          component: UserManagement
        },
        {
          path: '/user-withdrawal',
          name: 'UserWithdrawalManagement',
          component: UserWithdrawalManagement
        },
        {
          path: '/admin-management',
          name: 'AdminManagement',
          component: AdminManagement
        },
        {
          path: '/risk-management',
          name: 'RiskManagement',
          component: RiskManagement,
          meta: { title: '风控管理' }
        },
        {
          path: '/coin-flow',
          name: 'CoinFlowManagement',
          component: CoinFlowManagement,
          meta: { title: '收入明细' }
        },
        {
          path: '/notification',
          name: 'NotificationManagement',
          component: NotificationManagement,
          meta: { title: '公告管理' }
        },
        {
          path: '/game',
          name: 'GameManagement',
          component: GameManagement,
          meta: { title: '游戏管理' }
        },
        {
          path: '/web-game',
          name: 'WebGameManagement',
          component: WebGameManagement,
          meta: { title: '网页游戏列表' }
        },
        {
          path: '/leader-game',
          name: 'LeaderGameAssign',
          component: LeaderGameAssign,
          meta: { title: '创作者游戏分配' }
        },
        {
          path: '/device',
          name: 'DeviceInfoManagement',
          component: DeviceInfoManagement,
          meta: { title: '设备信息' }
        },
        {
          path: '/deduct-record',
          name: 'DeductRecordManagement',
          component: DeductRecordManagement,
          meta: { title: '扣量记录' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')

  if (to.path === '/login') {
    if (token) {
      next('/ad-revenue')
    } else {
      next()
    }
  } else if (to.path === '/') {
    if (token) {
      next('/ad-revenue')
    } else {
      next('/login')
    }
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
